import { getEfaxList } from "../../api/list";
import {EfaxPostAPI} from "../../api/create";
import {UpdateEfaxNumberAPI} from "../../api/update";
import {DeleteEfaxNumberAPI,DeleteMultipleEfaxAPI} from "../../api/delete";
import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";

// State interface definition
interface EfaxState {
  efaxList: any[];
  isLoading: boolean;
  error: string | null;
}
// Initial state setup
const initialState: EfaxState = {
  efaxList: [],
  isLoading: false,
  error: null,
};

// Async action to fetch efax list
export const FetchEfaxList = createAsyncThunk(
  "efax/fetchEfaxList",
  async (params: any, { dispatch, getState }) => {
    try {
      const res: any = await getEfaxList(params);
      const state: any = getState();
      const previousEfaxList = state.efax?.efaxList || []; // Extract the array correctly
        if ([1, undefined].includes(res?.result?.page)) {
          dispatch(getEfax(res?.result?.data || []));
        } else {
          dispatch(getEfax([
            ...previousEfaxList, // Keep existing data
            ...(res?.result?.data || []), // Append new data
          ]));
        }
      
      return res;
    } catch (error) {
      throw new Error('Error fetching efax list');
    }
  }
);

// create efax 

export const CreateEfaxNumber = createAsyncThunk(
  "efax/createEfaxNumber",
  async (data: any, { dispatch }) => {
    try {
      const res: any = await EfaxPostAPI(data);
      return res;
    } catch (error) {
      throw new Error('Error fetching efax list');
    }
  }
);

// update efax

export const UpdateEfaxNumber = createAsyncThunk(
  "efax/updateEfaxNumber",
  async ({id, params}: {id: any, params: any}, { dispatch }) => {
    try {
      const res: any = await UpdateEfaxNumberAPI(id, params);
      return res;
    } catch (error) {
      throw new Error('Error updating efax number');
    }
  }
);

export const DeleteEfaxNumber = createAsyncThunk(
  "efax/deleteEfaxNumber",
  async (id: any, { dispatch }) => {
    try {
      const res: any = await DeleteEfaxNumberAPI(id);
      return res;
    } catch (error) {
      throw new Error('Error deleting efax number');
    }
  }
);

export const DeleteMultipleEfax = createAsyncThunk(
  "efax/deleteMultipleEfax",
  async (params: any, { dispatch }) => {
    try {      
      const res: any = await DeleteMultipleEfaxAPI(params);
      return res;
    } catch (error) {
      throw new Error('Error deleting multiple efax numbers');
    }
  }
);


export const EfaxSlice = createSlice({
  name: "efax",
  initialState,
  reducers: {
    getEfax: (state: any, action: PayloadAction<any>) => {
      state = action.payload;
      return state;
    },
  },
});

export default EfaxSlice.reducer;
export const { getEfax } = EfaxSlice.actions;

